import React from 'react';
import PublicPolicyPage from 'src/components/public-policy-page';

const PrivacyPolicy: React.FC = () => (
  <PublicPolicyPage
    title="Privacy Policy"
    scriptSrc="https://app.enzuzo.com/scripts/privacy/02e5dbd2-1809-11f1-897f-f394f6e7fda1"
  />
);

export default PrivacyPolicy;
